var React = require('react');

function FlagGg (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M503.172 423.724H8.828A8.829 8.829 0 010 414.896V97.104a8.829 8.829 0 018.828-8.828h494.345a8.829 8.829 0 018.828 8.828v317.792a8.83 8.83 0 01-8.829 8.828z","fill":"#f5f5f5","key":0}),React.createElement("path",{"fill":"#ff4b55","d":"M512 220.69H291.31V88.276h-70.621V220.69H0v70.62h220.689v132.414h70.621V291.31H512z","key":1}),React.createElement("g",{"fill":"#ffe15a","key":2},[React.createElement("path",{"d":"M361.93 282.483v-52.966l-13.241 13.242H163.31l-13.241-13.242v52.966l13.241-13.242h185.379z","key":0}),React.createElement("path",{"d":"M229.517 361.931h52.965l-13.241-13.242V163.311l13.241-13.242h-52.965l13.241 13.242v185.378z","key":1})])]);
}

FlagGg.defaultProps = {"viewBox":"0 0 512.001 512.001"};

module.exports = FlagGg;

FlagGg.default = FlagGg;
